"use client";

import Image from "next/image";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination, Navigation } from "swiper/modules";
// import "swiper/css";
// import "swiper/css/pagination";

const images = [
  {
    src: "https://cdn.msu.edu.in/msu-reavamp/images/in-the-media/Skills-in-higher-education.jpg",
    alt: "Classroom learning session",
  },
  {
    src: "https://cdn.msu.edu.in/msu-reavamp/images/hostel/DSC00732-min.JPG",
    alt: "Workshop activity",
  },
  {
    src: "https://cdn.msu.edu.in/msu-reavamp/images/hostel/DSC00740-min.JPG",
    alt: "Lab session",
  },
  {
    src: "https://cdn.msu.edu.in/msu-reavamp/images/hostel/DSC00752-min.JPG",
    alt: "Group discussion",
  },
  {
    src: "https://cdn.msu.edu.in/msu-reavamp/images/hostel/DSC00753-min.JPG",
    alt: "Practical training",
  },
  {
    src: "https://cdn.msu.edu.in/msu-reavamp/images/hostel/DSC00757-min.JPG",
    alt: "Workplace exposure",
  },
];

export default function WhereLearningTakesForm() {
  return (
    <section className="page-container py-8 md:py-16 bg-white">
      {/* Header */}
      <div className="mb-12">
        <h2 className="text-3xl md:text-4xl font-bold mb-4">
          Where Learning Takes Form
        </h2>
        <p className="text-black text-sm md:text-base lg:text-lg max-w-4xl leading-relaxed">
          Learning comes alive across classrooms, labs, workshops, and
          workplaces. These moments reflect how knowledge transforms into skill
          through practice and experience.
        </p>
      </div>

      {/* Mobile Swiper (< 768px) */}
      <div className="block md:hidden">
        {/* Navigation Buttons */}
        <div className="flex justify-end gap-3 mb-4">
          <button
            id="wltfPrev"
            className="cursor-pointer bg-white border border-gray-300 rounded-full p-2 shadow-sm hover:bg-gray-50 transition-colors"
            aria-label="Previous"
          >
            <svg
              className="w-5 h-5 text-gray-700"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M15 19l-7-7 7-7"
              />
            </svg>
          </button>
          <button
            id="wltfNext"
            className="cursor-pointer bg-white border border-gray-300 rounded-full p-2 shadow-sm hover:bg-gray-50 transition-colors"
            aria-label="Next"
          >
            <svg
              className="w-5 h-5 text-gray-700"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M9 5l7 7-7 7"
              />
            </svg>
          </button>
        </div>

        <Swiper
          modules={[Autoplay, Pagination, Navigation]}
          spaceBetween={16}
          loop={true}
          slidesPerView={1.2}
          autoplay={{
            delay: 3000,
            disableOnInteraction: false,
          }}
          pagination={{ clickable: true }}
          navigation={{
            prevEl: "#wltfPrev",
            nextEl: "#wltfNext",
          }}
          className="where-learning-swiper w-full"
        >
          {images.map((image, index) => (
            <SwiperSlide key={index}>
              <div className="relative aspect-[4/3] overflow-hidden">
                <Image
                  src={image.src}
                  alt={image.alt}
                  fill
                  className="object-cover"
                />
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>

      {/* Desktop Grid (>= 768px) */}
      <div className="hidden md:grid grid-cols-2 lg:grid-cols-3 gap-6">
        {images.map((image, index) => (
          <div
            key={index}
            className="relative aspect-[4/3] overflow-hidden group"
          >
            <Image
              src={image.src}
              alt={image.alt}
              fill
              className="object-cover transition-transform duration-500 group-hover:scale-110"
            />
          </div>
        ))}
      </div>
    </section>
  );
}
